import Button, { BUTTON_VARIANT } from "@/components/Common/Button";
import styles from "./ProductsGrid.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * Card grid for product/category bands. Surface-aware (light | grey | dark).
 * Cards show title + optional description + optional icon. columns 2|3
 * (default 2); partial last row left-aligned.
 *
 * Optional trailing `cta: { text, href }` renders an outlined button below the
 * grid (Figma 4674-18539, "Explore Industry Solutions" on the chemical-toll
 * industries band). Omitted from config = no button, so pages without one are
 * unaffected.
 *
 * Optional `eyebrow` renders the small uppercase coral label above the heading
 * (Figma 5522-19278: "INDUSTRIES WE SERVE"). Omitted = no label, so bands and
 * pages that don't specify one are unaffected.
 */
export default function ProductsGrid({
  eyebrow,
  heading,
  subheading,
  items = [],
  columns = 2,
  surface = "light",
  cta,
}) {
  if (!items.length) return null;

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {subheading && <p className={styles.subheading}>{subheading}</p>}

        <div className={styles.grid} style={{ "--cols": columns }}>
          {items.map((item, i) => (
            <div className={styles.card} key={i}>
              {item.icon && (
                <span className={styles.iconWrap}>
                  <img src={resolveIcon(item.icon)} alt="" aria-hidden="true" />
                </span>
              )}
              <p className={styles.title}>{item.title}</p>
              {item.desc && <p className={styles.desc}>{item.desc}</p>}
            </div>
          ))}
        </div>

        {/* Shared Button; `styles.cta` now carries only the 20px offset. */}
        {cta?.text && (
          <Button
            variant={BUTTON_VARIANT.OUTLINE}
            href={cta.href || "/industry"}
            className={styles.cta}
          >
            {cta.text}
          </Button>
        )}
      </div>
    </section>
  );
}
